module.exports = __webpack_public_path__ + "img/arrow-down.1aad3cd1.svg";